module.exports = function ($, videojs) {
  'use strict';

  $(document).on('click', '.video-container .video-player', function () {
    var $self = $(this);
    if ($self.children('video').length === 0)
      videojs($self.attr('id'), {
        autoplay: true,
        controls: true,
        preload: 'auto',
      });
  });
};
